import TemplateView from '../../../../TemplateView'
import ReportDescriptionSection from './ReportDescriptionSection'
import ChooseReportSection from './ChooseReportSection'
import {ReportType} from '../../../constants'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getAccessRights, hasPto, hasSick} from '../../../../loggedInUser/selectors'
import {selectFeatures} from '../../../../features/selectors'
import {getSelectedTab} from '../../createReportPopup/selectors'
import {changeTab} from '../../createReportPopup/actions'
import {isReportAvailable} from '../../createReportPopup/utils'
import {isAllUsersTimeTrackAvailable, isOvertimeAvailable} from '../../../authorizationInfo/selectors'

class ChooseReportComponent extends TemplateView {
    constructor({
        reportUrls = {},
        reportNameKeys = {},
        changeTab = () => {},
    }) {
        super()

        this.params = {
            reportUrls,
            reportNameKeys,
        }

        this.actions = {
            changeTab,
        }

        this.state = {
            selectedType: null,
            userRights: {},
            userInDar: false,
            overtimeAvailable: false,
            hasSick: false,
            hasPTO: false,
        }

        this.onAnyStatePropertyChanged(['selectedType', 'userRights', 'features', 'userInDar', 'hasSick', 'hasPTO', 'overtimeAvailable'], (state) => {
            this.chooseReport.setState({
                selectedType: state.selectedType,
                userRights: state.userRights,
                features: state.features,
            })

            this.descriptionReport.setState({
                selectedType: state.selectedType,
                userInDar: state.userInDar,
                overtimeAvailable: state.overtimeAvailable,
                enabledFeatures: state.features,
                userRights: state.userRights,
                hasSick: state.hasSick,
                hasPTO: state.hasPTO,
            })

            const isBillingTab = state.tab === ReportType.BILLING_SUMMARY || state.tab === ReportType.INVOICING ||
                                 state.tab === ReportType.COST_OF_WORK || state.tab === ReportType.PROFIT_LOSS
            this.find('.reportDescription_section').toggleClass('timeReport', !isBillingTab)
            this.find('.reportDescription_section').toggleClass('billingReport', isBillingTab)
        })
    }

    templateHtml() {
        return "<div class='chooseReport_content'>" +
               "  <div class='chooseReport_section'></div>" +
               "  <div class='reportDescription_section'></div>" +
               "</div>"
    }

    afterRender() {
        this.chooseReport = new ChooseReportSection({
            reportNameKeys: this.params.reportNameKeys,
            tabSelected: (tab) => this.actions.changeTab(tab)
        }).init(this.find('.chooseReport_section'))

        this.descriptionReport = new ReportDescriptionSection({
            reportNameKeys: this.params.reportNameKeys,
            reportUrls: this.params.reportUrls,
        }).init(this.find('.reportDescription_section'))

        const selectedType =  Object.values(ReportType).find(type => isReportAvailable(type, this.state.userRights, this.state.features))

        this.actions.changeTab(!!selectedType ? selectedType : ReportType.STAFF_PERFORMANCE)
    }
}

export default connect(
    (state) => ({
        selectedType: getSelectedTab(state),
        userRights: getAccessRights(state),
        features: selectFeatures(state),
        hasPTO: hasPto(state),
        hasSick: hasSick(state),
        overtimeAvailable: isOvertimeAvailable(state),
        userInDar: isAllUsersTimeTrackAvailable(state),
    }),
    (dispatch) => ({
        changeTab: bindActionCreators(changeTab, dispatch),
    })
)(ChooseReportComponent)


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ChooseReportComponent.js